export default {"src":"/_next/static/media/certificado-de-alistamento-militar.c9cb7a00.svg","height":511,"width":339,"blurWidth":0,"blurHeight":0};